// Tab-Umschaltung ohne Bootstrap-JS. Ersetzt bootstrap/js/dist/tab.
// Die Anzeige-Logik liegt im CSS (parts/nav.scss): .tab-content > .tab-pane { display:none }
// und .tab-content > .active { display:block }. Wir togglen nur die Klassen.

const $slickSlider = $('.slick-slider');

$('.nav-tabs a').on('click', function (e) {
  e.preventDefault();

  const $link = $(this);
  if ($link.hasClass('active')) {
    return;
  }

  // Ziel-Pane ermitteln (href="#id" oder data-target)
  const target = $link.attr('href') || $link.data('target');
  const $target = target ? $(target) : $();

  // aktiven Tab innerhalb dieser Tab-Leiste umsetzen
  const $navTabs = $link.closest('.nav-tabs');
  $navTabs.find('a').removeClass('active');
  $navTabs.find('.nav-item').removeClass('show');
  $link.addClass('active');
  $link.closest('.nav-item').addClass('show');

  // Panes umschalten
  const $content = $target.closest('.tab-content');
  $content.children('.tab-pane').removeClass('active show');
  $target.addClass('active show');

  // Slick muss neu berechnen, sobald der Slider sichtbar ist (vormals shown.bs.tab)
  if ($slickSlider.length && $slickSlider.hasClass('slick-initialized')) {
    $slickSlider.slick('refresh');
  }
});
